var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"candidate-view"},[_c('candidate-content',{attrs:{"candidateData":_vm.selectedCandidate,"candidateUnavailable":_vm.candidateUnavailable,"copy":_vm.copy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }